import { render, staticRenderFns } from "./popup-department-title-do.vue?vue&type=template&id=52fe774d&scoped=true"
import script from "./popup-department-title-do.vue?vue&type=script&lang=js"
export * from "./popup-department-title-do.vue?vue&type=script&lang=js"
import style0 from "./popup-department-title-do.vue?vue&type=style&index=0&id=52fe774d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe774d",
  null
  
)

export default component.exports